/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespBrowseHeader_searchBrowse$ref = any;
type SbRespContentModuleSelector_searchBrowse$ref = any;
type SbRespMoreWaysToBrowse_searchBrowse$ref = any;
type SbRespNullSearchResults_searchBrowse$ref = any;
type SbRespPageSize_searchBrowse$ref = any;
type SbRespRefineMenu_filters$ref = any;
type SbRespRefineMenu_searchBrowse$ref = any;
type SbRespSearchResultContainer_searchBrowse$ref = any;
type SbRespSortItems_searchBrowse$ref = any;
type SbRespTradeOnApprovalPromoBanner_searchBrowse$ref = any;
type SbSharedBillboardAd_searchBrowse$ref = any;
type SbSharedPageBreadcrumbs_searchBrowse$ref = any;
type SbSharedRelatedItems_searchBrowse$ref = any;
type SbSharedSkyscraperAd_searchBrowse$ref = any;
type SbSharedTitle_searchBrowse$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsComponents_searchBrowse$ref: FragmentReference;
export type SbRespCollectionsComponents_searchBrowse = {|
  +displayUriRef: ?string,
  +topCategoryL1: ?VerticalType,
  +totalResults: ?number,
  +displayMaxNumberOfPages: ?number,
  +pageType: ?string,
  +filters: ?$ReadOnlyArray<?{|
    +$fragmentRefs: SbRespRefineMenu_filters$ref
  |}>,
  +appliedFilters: ?$ReadOnlyArray<?{|
    +name: ?string,
    +values: ?$ReadOnlyArray<?{|
      +urlLabel: ?string
    |}>,
  |}>,
  +$fragmentRefs: SbRespRefineMenu_searchBrowse$ref & SbRespContentModuleSelector_searchBrowse$ref & SbRespNullSearchResults_searchBrowse$ref & SbSharedPageBreadcrumbs_searchBrowse$ref & SbRespSearchResultContainer_searchBrowse$ref & SbSharedTitle_searchBrowse$ref & SbRespBrowseHeader_searchBrowse$ref & SbRespSortItems_searchBrowse$ref & SbRespPageSize_searchBrowse$ref & SbSharedBillboardAd_searchBrowse$ref & SbSharedSkyscraperAd_searchBrowse$ref & SbSharedRelatedItems_searchBrowse$ref & SbRespMoreWaysToBrowse_searchBrowse$ref & SbRespTradeOnApprovalPromoBanner_searchBrowse$ref,
  +$refType: SbRespCollectionsComponents_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_searchBrowse",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayMaxNumberOfPages",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespContentModuleSelector_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_searchBrowse",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedBillboardAd_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedSkyscraperAd_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMoreWaysToBrowse_searchBrowse",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "filters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseFilter",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespRefineMenu_filters",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "appliedFilters",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "values",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "urlLabel",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SbRespTradeOnApprovalPromoBanner_searchBrowse",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e40d8ff3f658a48dbed44bdc913a9554';
module.exports = node;
